import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from "vuex";
import { SEND_TEST_EMAIL } from "@Broker/@Modules/marketing/store/templates/templates-actions";
import MaterialInput from "@Shared/components/inputs/material-input";
import { GenericModal } from "@Shared/components/modals";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { showToast } from "@Shared/@Utils/constants";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SendTestEmailModal",
  components: {
    MaterialInput,
    GenericModal,
    SimpleButton
  },
  mixins: [validationMixin],
  validations: {
    emailAddress: {
      required,
      email
    }
  },
  props: {
    templateId: {
      type: [String, Number],
      required: true
    },
    testHtml: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      emailAddress: "",
      loading: false,
      sendSucceeded: true
    };
  },
  computed: _objectSpread({}, mapState("AccountStore", {
    email(state) {
      return state.userDetails.email;
    }
  })),
  mounted() {
    this.emailAddress = this.email;
  },
  methods: _objectSpread(_objectSpread({}, mapActions("TemplatesStore", [SEND_TEST_EMAIL])), {}, {
    showModal() {
      this.$refs.modal.show();
    },
    hideModal() {
      this.$refs.modal.hide();
    },
    async handleSendEmail() {
      const data = {
        html: this.testHtml,
        email: this.emailAddress
      };
      try {
        this.loading = true;
        await this.SEND_TEST_EMAIL({
          templateId: this.templateId,
          data
        });
        this.sendSucceeded = true;
        showToast("success", "emailSentCheckInbox");
        this.hideModal();
      } catch (error) {
        this.sendSucceeded = false;
      } finally {
        this.loading = false;
      }
    }
  })
});